import PhotoGrid from "components/common/PhotoGrid"
import PhotoSlider from "components/common/PhotoSlider"
import PropTypes from "prop-types"
import React, { useState } from "react"
import { VideoPlayerModal } from "ui/VideoPlayerModal"
import { isMediaFileVideo, getMediaUrl } from "utils/media-upload"

const PreviewMediaListingComponent = ({ trip }) => {
  const [videoModalOpen, setVideoModalOpen] = useState(false)
  const [selectedMedia, setSelectedMedia] = useState(null)

  const { 
    photos = [], 
    cropped_photos = [], 
    videos = [],
    trimmed_videos = [] 
  } = trip
  
  // Combine all media types into a single array
  const media = [
    ...photos.map(photo => ({ ...photo, type: 'photo' })),
    ...cropped_photos.map(photo => ({ ...photo, type: 'cropped_photo' })),
    ...videos.map(video => ({ ...video, type: 'video' })),
    ...trimmed_videos.map(video => ({
      ...video,
      type: 'trimmed_video',
      // Use getMediaUrl to get the best available thumbnail
      thumbnail_url: getMediaUrl(video)
    }))
  ]

  // Sort media items by position, ensuring items without position are placed at the end
  const sortedMedia = media
    .map(item => ({
      ...item,
      position: item.position 
    }))
    .sort((a, b) => (a.position || 0) - (b.position || 0))

  const handleMediaClick = (media) => {
    if (isMediaFileVideo(media)) {
      setSelectedMedia(media)
      setVideoModalOpen(true)
    }
  }

  const handleCloseVideoModal = () => {
    setVideoModalOpen(false)
    setSelectedMedia(null)
  }

  return (
    <div>
      <div className="d-none d-lg-block">
        <PhotoGrid photos={sortedMedia} handleMediaClick={handleMediaClick} />
      </div>
      <div className="d-block d-lg-none">
        <PhotoSlider photos={sortedMedia} ratio="1x1" className="w-100 h-100 mt-20" />
      </div>
      <VideoPlayerModal open={videoModalOpen} handleClose={handleCloseVideoModal} selectedMedia={selectedMedia} />
    </div>
  )
}

PreviewMediaListingComponent.propTypes = {
  trip: PropTypes.shape({
    photos: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        url: PropTypes.string.isRequired,
        placeholder_url: PropTypes.string,
        position: PropTypes.number
      })
    ),
    cropped_photos: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        url: PropTypes.string.isRequired,
        placeholder_url: PropTypes.string,
        position: PropTypes.number
      })
    ),
    videos: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        url: PropTypes.string.isRequired,
        placeholder_url: PropTypes.string,
        type: PropTypes.string,
        position: PropTypes.number
      })
    ),
    trimmed_videos: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        url: PropTypes.string.isRequired,
        placeholder_url: PropTypes.string,
        preview_url: PropTypes.string,
        thumbnail_url: PropTypes.string,
        type: PropTypes.string,
        position: PropTypes.number
      })
    )
  }).isRequired
}

export const PreviewMediaListing = React.memo(PreviewMediaListingComponent)

